import React from "react"
import { ToastContainer, cssTransition } from "react-toastify"

const Zoom = cssTransition({
  enter: "zoomIn",
  exit: "zoomOut",
  duration: [200, 200]
})

export default () => {
  return (
    <ToastContainer
      transition={Zoom}
      hideProgressBar
      position="bottom-center"
      autoClose={2000}
    />
  )
}
